import { useEffect, useState } from 'react';

const useInitialHydration = (hydrate: () => void) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    if (isHydrated) return;

    hydrate();
    setIsHydrated(true);
  }, [hydrate, isHydrated]);

  return isHydrated;
};

export default useInitialHydration;
